import { cva } from 'class-variance-authority';

/**
 * Collage "stamped sticker" button variants. Built on the `.ww-btn` foundation
 * classes so it carries the hard offset shadow + press interaction by default.
 * Kept in its own file so the component module only exports a component
 * (react-refresh/only-export-components).
 */
export const buttonVariants = cva('ww-btn', {
  variants: {
    variant: {
      default: 'ww-btn--ink',
      primary: 'ww-btn--primary',
      ink: 'ww-btn--ink',
      chart: 'ww-btn--chart',
      ghost: 'ww-btn--ghost',
      outline: 'ww-btn--ghost',
    },
    size: {
      default: '',
      lg: 'ww-btn--lg',
      block: 'ww-btn--block',
      blockLg: 'ww-btn--block ww-btn--lg',
    },
  },
  defaultVariants: { variant: 'default', size: 'default' },
});
